// Initialize Firebase
// TODO: Replace with your project's customized code snippet
export var config = {
    apiKey: "AIzaSyCTbmn4vT9elTkTbHRkE0tvDd8y-ge5Nkk",
    authDomain: "events-create-react.firebaseapp.com",
    databaseURL: "https://events-create-react.firebaseio.com",
    projectId: "events-create-react",
    storageBucket: "events-create-react.appspot.com",
    messagingSenderId: "446266207187"
  };


// WEBPACK FOOTER //
// ./src/server/Config.js